module.exports = new __parcel__URL__("coinIcon.89137236.svg").toString();